import { makeStyles } from '@cuda-networks/bds-core'

export default makeStyles({
  title: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 400
  }
})
